<template>
  <div class="resume">
    <div class="resume-editor" ref="editorFrom">
      <div>
        <!-- 求职意向 -->
        <div class="resumeSection">
          <div>
            <h2 class="resumeSection__title">求职意向</h2>
          </div>
          <div class="resumeSection__form">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item label="期望工作地" prop="workingPlace">
                <el-cascader
                  ref="cascaderArea"
                  style="width: 100%"
                  filterable
                  clearable
                  :props="{
                    value: 'value',
                    label: 'label',
                    multiple: true,
                    emitPath: false,
                  }"
                  :show-all-levels="false"
                  :options="areaDataTree"
                  v-model="form.workingPlace"
                  @change="AreaInfoChange"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="期望职位" prop="jobPosition">
                <el-cascader
                  ref="cascaderJob"
                  style="width: 100%"
                  filterable
                  clearable
                  :props="{
                    value: 'value',
                    label: 'label',
                    multiple: true,
                    emitPath: false,
                    checkStrictly: true, // 关键：关闭父子关联，允许单独选中子节点
                  }"
                  :show-all-levels="false"
                  :options="classDataTree"
                  v-model="form.jobPosition"
                  @change="reTradeChange"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="薪酬类型" prop="hopeSalaryType">
                <el-select
                  v-model="form.hopeSalaryType"
                  placeholder="请选择薪酬类型"
                  clearable
                  style="width: 100%"
                  @change="updateMarks"
                >
                  <el-option
                    v-for="(item, index) in salaryType"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="期望薪资(滑块两个值都为0是，为面议)"
                prop="hopeSalary"
              >
                <el-slider
                  v-model="hopeSalary"
                  range
                  :max="100"
                  :marks="marks"
                  style="margin-top: 50px"
                  @change="getHopeSalary"
                >
                </el-slider>
              </el-form-item>
              <el-form-item label="求职状态" prop="jobSeeking">
                <el-select
                  v-model="form.jobSeeking"
                  placeholder="请选择求职状态"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in jobStatus"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div ref="footerAction" class="resumeEditor-footerAction">
      <el-button round @click="$router.push('/resume')">取消</el-button>
      <el-button size="medium" @click="submit" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import {
  personalInfo,
  areaInfoHuBeiList,
  reTradeList,
  personalInfoCommit,
} from "@/api/index";
import { Debounce, handleTree } from "@/helper/utilities.js";
export default {
  name: "resume-intention",
  data() {
    // 自定义验证规则 - 检查选择数量不超过3个
    const validateSelection = (rule, value, callback) => {
      if (value.length > 3) {
        callback(new Error("最多只能选择3个选项"));
      } else {
        callback();
      }
    };
    return {
      jobStatus: [
        "正在找工作-随时到岗",
        "在职-暂无跳槽打算",
        "在职-正考虑换工作",
        "在职-有更好的机会也可以考虑",
      ],
      salaryType: ["月薪", "年薪"],
      areaDataTree: [], // 省市区三级联数据，纯汉字
      selectedOptions: [],
      classDataTree: [], //行业
      TreeOptions: [],
      hopeSalary: [0, 100],
      salaryUnit: "k", // 默认单位
      // marks: {
      //   0: {
      //     style: {
      //       color: "#1989FA",
      //     },
      //     label: this.$createElement("strong", "面议"),
      //   },
      //   92: {
      //     style: {
      //       color: "#1989FA",
      //     },
      //     label: this.$createElement("strong", `单位(${this.Unit})`),
      //   },
      // },
      marks: {},
      form: {
        workingPlace: [],
        reserveFieldA: [],
        jobPosition: [],
        reserveFieldB: [],
        hopeSalaryType: undefined,
        hopeSalary: "面议",
        jobSeeking: undefined,
      },
      rules: {
        jobPosition: [
          { required: true, message: "期望职位不能为空", trigger: "change" },
          { validator: validateSelection, trigger: "change" },
        ],
        hopeSalaryType: [
          { required: true, message: "薪酬类型不能为空", trigger: "change" },
        ],
        hopeSalary: [
          { required: true, message: "期望薪资不能为空", trigger: "blur" },
        ],
        jobSeeking: [
          { required: true, message: "求职状态不能为空", trigger: "change" },
        ],
        workingPlace: [
          { required: true, message: "期望工作地不能为空", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getAreaInfo();
    this.getreTradeList();
    this.getPersonalInfo();
    setTimeout(() => {
    this.updateMarks(this.form.hopeSalaryType);
  }, 100);
  },
  methods: {
    getPersonalInfo() {
      personalInfo()
        .then((res) => {
          if (res.code == 200) {
            if (res.data.reMiniProgramPerson) {
              if (!res.data.reMiniProgramPerson.hasOwnProperty("hopeSalary")) {
                this.$set(res.data.reMiniProgramPerson, "hopeSalary", "面议");
              }
              this.form = res.data.reMiniProgramPerson;
              if (res.data.reMiniProgramPerson.workingPlace) {
                this.form.workingPlace =
                  res.data.reMiniProgramPerson.workingPlace.split(",");
              }
              if (res.data.reMiniProgramPerson.jobPosition) {
                this.form.jobPosition =
                  res.data.reMiniProgramPerson.jobPosition.split(",");
              }
              if (res.data.reMiniProgramPerson.hopeSalary == "面议") {
                this.hopeSalary = [0, 0];
              } else {
                let array = res.data.reMiniProgramPerson.hopeSalary.split("-");
                let arr = [];
                array.forEach((item) => {
                  arr.push(this.removeSpaces(item));
                });
                this.hopeSalary = arr;
              }
            }
          }
        })
        .catch((err) => {});
    },

    // 去除字母
    removeSpaces(str) {
      return str.replace(/[a-zA-Z]/g, "");
    },

    //获取地区
    getAreaInfo() {
      areaInfoHuBeiList().then((res) => {
        const data = res.data.filter((item) => item.level !== "3");
        let list = handleTree(data, "areaId", "parentId");
        this.areaDataTree = this.changeAreaInfoListFiled(list);
      });
    },

    changeAreaInfoListFiled(list) {
      let newList = [];
      if (list && list.length > 0) {
        list.forEach((t) => {
          let newItem = {
            label: t.areaName,
            value: t.areaCode,
            parentId: t.parentId,
            areaCode: t.areaCode,
            children: t.children,
          };
          newList.push(newItem);
          if (t.children && t.children.length > 0) {
            newItem.children = this.changeAreaInfoListFiled(t.children);
          }
        });
      }
      return newList;
    },

    AreaInfoChange() {
      // 获取组件实例
      const cascader = this.$refs.cascaderArea;
      // 获取所有选中的节点对象（包含完整信息）
      const selectedNodes = cascader.getCheckedNodes();
      // 提取关键信息（可选）
      const result = selectedNodes.map((node) => ({
        label: node.label,
        value: node.value,
        // 可以添加其他需要的属性
        pathLabels: node.pathLabels, // 完整路径的标签数组
      }));
      let newList = [];
      result.forEach((t) => {
        newList.push(t.label);
      });
      this.form.reserveFieldA = newList;
    },

    //获取行业
    getreTradeList() {
      reTradeList().then((res) => {
        res.data.shift();
        let list = handleTree(res.data, "tradeId", "parentId");
        let originalData = this.changeListFiled(list);
        this.classDataTree = this.addDisabledToLevels(originalData);
      });
    },

    addDisabledToLevels(data, level = 1) {
      return data.map((item) => {
        // 复制原节点（避免修改原数据）
        const newItem = { ...item };

        // 一级（level=1）和二级（level=2）节点添加 disabled: true
        if (level === 1 || level === 2) {
          newItem.disabled = true;
        }

        // 如果有子节点，递归处理（层级+1）
        if (item.children && item.children.length > 0) {
          newItem.children = this.addDisabledToLevels(item.children, level + 1);
        }

        return newItem;
      });
    },

    changeListFiled(list) {
      let newList = [];
      if (list && list.length > 0) {
        list.forEach((t) => {
          let newItem = {
            label: t.tradeName,
            value: t.tradeId,
            parentId: t.parentId,
            children: t.children,
          };
          newList.push(newItem);
          if (t.children && t.children.length > 0) {
            newItem.children = this.changeListFiled(t.children);
          }
        });
      }
      return newList;
    },

    reTradeChange(value) {
      if (value.length < 4) {
        // 获取组件实例
        const cascader = this.$refs.cascaderJob;
        // 获取所有选中的节点对象（包含完整信息）
        const selectedNodes = cascader.getCheckedNodes();
        // 提取关键信息（可选）
        const result = selectedNodes.map((node) => ({
          label: node.label,
          value: node.value,
          // 可以添加其他需要的属性
          pathLabels: node.pathLabels, // 完整路径的标签数组
        }));
        let newList = [];
        result.forEach((t) => {
          newList.push(t.label);
        });
        this.form.reserveFieldB = newList;
      }
    },

    // 更新marks中的单位标签
    updateMarks(e) {
      if (e == "月薪") {
        this.salaryUnit = "k";
      } else if (e == "年薪") {
        this.salaryUnit = "w";
      }
      this.marks = {
        0: {
          style: { color: "#1989FA" },
          label: this.$createElement("strong", "面议"),
        },
        90: {
          style: { color: "#1989FA" },
          // 根据当前选中的单位动态生成标签
          label: this.$createElement("strong", `单位(${this.salaryUnit})`),
        },
      };
    },

    getHopeSalary(value) {
      if (value[0] == 0 && value[1] == 0) {
        this.form.hopeSalary = "面议";
      } else {
        this.form.hopeSalary = value[0] + this.salaryUnit + "-" + value[1] + this.salaryUnit;
      }
    },

    submit: Debounce(function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.workingPlace = this.form.workingPlace.toString(",");
          this.form.reserveFieldA = this.form.reserveFieldA.toString(",");
          this.form.jobPosition = this.form.jobPosition.toString(",");
          this.form.reserveFieldB = this.form.reserveFieldB.toString(",");
          personalInfoCommit(this.form).then((res) => {
            if (res.code == 200) {
              this.$router.go(-1);
              this.$message({
                showClose: true,
                message: "保存成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "warning",
              });
            }
          });
        }
      });
    }, 1000),
  },
};
</script>

<style lang="less" scoped>
.resume {
  margin-bottom: 30px;
}
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 30px 0;
}
.resumeEditor-footerAction {
  width: 900px;
  margin: auto;
  z-index: 33;
  text-align: right;
  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}
.resumeSection {
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @border-base-color;

  &__title {
    margin-right: 200px;

    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }
  &__form {
    width: 600px;
  }
}
</style>
